import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { read, utils } from 'xlsx'
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import MaterialTable from 'material-table'
import Typography from '@material-ui/core/Typography'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import { saveBestTeachingAwardFromUploadRequest } from '../../services/saga'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import moment from 'moment-timezone'
const inseadCanvasAdminStorage =
  JSON.parse(localStorage.getItem('inseadCanvasAdmin')) || null
function StepOne() {
  const history = useHistory();
  const [isUploaded, setIsUploaded] = React.useState(false)
  const [configureData, setConfigureData] = React.useState([])
  const [isFetchingData, setIsFetchingData] = React.useState(false)
  const [openSnackbar, setOpenSnackbar] = React.useState(false)
  const [snackbarMessage, setSnackbarMessage] = React.useState('')
  const [lastUpdatedAt, setLastUpdatedAt] = React.useState('')
  const [lastUpdatedBy, setLastUpdatedBy] = React.useState('')
  const headerConfigure = [
    {
      title: 'Professor',
      field: 'Professor',
      tableData: {
        columnOrder: 0,
        groupSort: 'asc',
        width: 'calc((100% - (0px)) / 7)',
        id: 0
      }
    },
    {
      title: 'Prof ID',
      field: 'Prof ID',
      tableData: {
        columnOrder: 1,
        groupSort: 'asc',
        width: 'calc((100% - (0px)) / 7)',
        id: 1
      }
    },
    {
      title: 'Course',
      field: 'Course',
      tableData: {
        columnOrder: 2,
        groupSort: 'asc',
        width: 'calc((100% - (0px)) / 7)',
        id: 2
      }
    },
    {
      title: 'Campus',
      field: 'Campus',
      tableData: {
        columnOrder: 3,
        groupSort: 'asc',
        width: 'calc((100% - (0px)) / 7)',
        id: 3
      }
    },
    {
      title: 'Enrolled',
      field: 'Enrolled',
      tableData: {
        columnOrder: 4,
        groupSort: 'asc',
        width: 'calc((100% - (0px)) / 7)',
        id: 4
      }
    },
    {
      title: 'Type',
      field: 'Type',
      tableData: {
        columnOrder: 5,
        groupSort: 'asc',
        width: 'calc((100% - (0px)) / 7)',
        id: 5
      }
    },
    {
      title: 'Course ID',
      field: 'Course ID',
      tableData: {
        columnOrder: 6,
        groupSort: 'asc',
        width: 'calc((100% - (0px)) / 7)',
        id: 6
      }
    }
  ]
  const [openingDate, setOpeningDate] = useState(null)
  const [openWarningDialog, setOpenWarningDialog] = React.useState(false)
  const [openInvalidUploadTemplate, setOpenInvalidUploadTemplate] =
    React.useState(false)

  const handleFileUpload = async (e) => {
    const file = e.target.files[0]
    if (!file) {
      return
    }
    setIsFetchingData(true)
    const dataFile = await file.arrayBuffer()
    const wb = read(dataFile)
    const ws = wb.Sheets[wb.SheetNames[0]] // get the first worksheet
    const data = utils.sheet_to_json(ws) // generate objects
    /* parse the header */
    const column = Object.keys(data[0])
    /* validate the column */
    /**
     * @todo validate on each column value
     */
    if (column.length === 0) {
      setOpenInvalidUploadTemplate(true)
      return
    }
    /* Modify the column */
    const modifyColumn = column.map((valueContent) => ({
      title: valueContent,
      field: valueContent
    }))
    /* Save the column to state */
    const cleanData = data.map((value) => {
      return {
        ...value,
        created_at: moment.tz().utc().format('YYYY-MM-DD hh:mm:ss'),
        updated_at: moment.tz().utc().format('YYYY-MM-DD hh:mm:ss'),
        created_by: inseadCanvasAdminStorage.user.name,
        updated_by: inseadCanvasAdminStorage.user.name
      }
    })
    try {
      await saveBestTeachingAwardFromUploadRequest(cleanData)
      setConfigureData(cleanData)
      setIsUploaded(true)
      setIsFetchingData(false)
      setOpenSnackbar(true)
      setSnackbarMessage('Data has been uploaded successfully')
      getLastUpdatedAt();
    } catch (e) {
      setOpenSnackbar(true)
      setSnackbarMessage('Upload failed: Invalid excel file')
      setIsFetchingData(false)
    }
  }

  const handleBack = () => {
    history.push('/best-teaching-award-reports');
  }

  const getLastUpdatedAt = () => {
    axios
        .get(
            `${process.env.REACT_APP_BEST_TEACHING_BASE_URL_API}/best-teaching-reports/api/last-updated-info`
        )
        .then((response) => {
          if(response.data.data) {
            setLastUpdatedBy(response.data.data[0].updated_by)
            setLastUpdatedAt(response.data.data[0].updated_at)
          }
        })
        .catch(() => {
          setOpenSnackbar(true)
          setSnackbarMessage('Error when get last updated at')
        })
  }


  useEffect(() => {
    setIsFetchingData(true)
    getLastUpdatedAt();
    axios
      .get(
        `${process.env.REACT_APP_BEST_TEACHING_BASE_URL_API}/best-teaching-reports/api/opening-date?user_name=${inseadCanvasAdminStorage.user.name}`
      )
      .then((response) => {
        if (response.data.data.length > 0) {
          setOpeningDate(response.data.data[0].opening_date)
        }
      })
      .catch(() => {
        setOpenSnackbar(true)
        setSnackbarMessage('Error when get opening date')
      })
    axios
      .get(
        `${process.env.REACT_APP_BEST_TEACHING_BASE_URL_API}/best-teaching-reports/api/import/excel`,
        {
          params: {
            ...(inseadCanvasAdminStorage !== null
              ? {
                  user_id: inseadCanvasAdminStorage.user.name
                }
              : {})
          }
        }
      )
      .then((response) => {
        if (response.data.data.length > 0) {
          const dataResponse = response.data.data.map((value) => {
            return {
              Campus: value.campus,
              Course: value.course,
              'Course ID': value.course_id,
              Enrolled: value.enrolled,
              'Prof ID': value.professor_id,
              Professor: value.professor,
              Type: value.type,
              updated_at: value.updated_at,
              tableData: value.tableData
            }
          })
          /* parse the header */
          const column = Object.keys(dataResponse[0])
          /* validate the column */
          /**
           * @todo validate on each column value
           */
          if (column.length === 0) {
            setOpenInvalidUploadTemplate(true)
            return
          }
          setConfigureData(dataResponse)
          setIsFetchingData(false)
          setIsUploaded(true)
        }
      })
      .catch((err) => {
        setIsFetchingData(false)
        setOpenSnackbar(true)
        setSnackbarMessage('Error when get excel data')
      })
  }, [])

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openSnackbar}
        autoHideDuration={10000}
        onClose={() => {
          setOpenSnackbar(false)
        }}
      >
        <SnackbarContent
          style={{
            backgroundColor: '#015548',
            color: 'white',
            fontWeight: 'bold'
          }}
          message={<span id='client-snackbar'>{snackbarMessage}</span>}
        />
      </Snackbar>
      <FormControl fullWidth style={{ marginBottom: '24px' }}>
        {configureData.length > 0 ? (
          <div
            style={{
              marginTop: '16px',
              marginBottom: '16px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between'
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '16px',
                justifyContent: 'flex-end'
              }}
            >
              <div>
                <Typography variant='subtitle2' component='p'>
                  BTA Vote Opening Date
                </Typography>
              </div>
              <div>
                <input
                  value={moment(openingDate).format('YYYY-MM-DD')}
                  onChange={(event) => {
                    const value = event.target.value
                    const payload = {
                      opening_date: value,
                      created_at: moment
                        .tz()
                        .utc()
                        .format('YYYY-MM-DD hh:mm:ss'),
                      updated_at: moment
                        .tz()
                        .utc()
                        .format('YYYY-MM-DD hh:mm:ss'),
                      created_by: inseadCanvasAdminStorage.user.name,
                      updated_by: inseadCanvasAdminStorage.user.name
                    }
                    axios
                      .post(
                        `${process.env.REACT_APP_BEST_TEACHING_BASE_URL_API}/best-teaching-reports/api/opening-date`,
                        payload
                      )
                      .then((response) => {
                        setOpeningDate(value)
                        console.log('response', response)
                      })
                      .catch(() => {})
                  }}
                  type={'date'}
                />
              </div>
            </div>
            <div>
              <div
                style={{
                  display: 'flex',
                  gap: '8px'
                }}
              >
                {
                  lastUpdatedAt ? (
                      <>
                        <Typography variant='subtitle2' component='p'>
                          Last updated at
                        </Typography>
                        <div style={{ width: '200px' }}>
                          {moment(lastUpdatedAt)
                              .utc()
                              .format('DD MMM YYYY hh:mm')}
                        </div>
                      </>
                  ) : null
                }

              </div>
              <div
                style={{
                  display: 'flex',
                  gap: '8px'
                }}
              >
                {
                  lastUpdatedBy ? (
                      <>
                        <Typography variant='subtitle2' component='p'>
                          Last updated by
                        </Typography>
                        <div style={{ width: '200px' }}>
                          {lastUpdatedBy}
                        </div>
                      </>
                  ) : null
                }
              </div>
            </div>
          </div>
        ) : null}
        <Dialog
          open={openInvalidUploadTemplate}
          onClose={() => {
            setOpenInvalidUploadTemplate(false)
          }}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>Warning</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              Template not valid
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenInvalidUploadTemplate(false)
              }}
              color='primary'
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </FormControl>
      {configureData.length === 0 && isFetchingData === false ? (
        <div>No data found</div>
      ) : null}

      {isUploaded && (
        <>
          <MaterialTable
            isLoading={isFetchingData}
            options={{
              paging: true,
              pageSize: 10
            }}
            columns={headerConfigure}
            data={configureData}
            title='Professor and Course List'
          />
        </>
      )}
      <div
        style={{
          paddingTop: '24px',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <Button variant='contained' onClick={handleBack} color='primary'>
            Back
          </Button>
        </div>
        <div style={{ display: 'flex', gap: '16px' }}>
          <Button
            onClick={() => {
              window.location.href = '/Template_Setup_DDMMYYYY.xls'
            }}
            variant='contained'
            color={'primary'}
          >
            Download BTA template
          </Button>
          <Button variant='contained' color={'primary'} component={'label'}>
            Upload File
            <input
              onChange={handleFileUpload}
              type='file'
              hidden
              accept='xlsx'
            />
          </Button>
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    data: state.BestTeachingAwardReport
  }
}

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(StepOne)
